import { Component } from '@angular/core';

@Component({
  selector: 'om-svg-video-chat-circled',
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
      <rect width="48" height="48" rx="24" fill="#C5E5DD" />
      <path
        style="stroke:none;fill-rule:nonzero;fill:#004d49;fill-opacity:1"
        d="M8.32 32.621a.47.47 0 0 0-.097.656.47.47 0 0 0 .656.102ZM15.496 16.2l-.457-.09-.008.047Zm-1.101 11.598-.47-.043ZM8.879 33.38l4.887-3.606-.555-.753-4.89 3.601Zm5.98-5.535 1.106-11.598-.934-.09-1.105 11.598Zm1.098-11.551c.055-.273.121-.645.29-.957.155-.281.37-.469.753-.469v-.937c-.82 0-1.305.465-1.574.957-.254.465-.34.992-.387 1.222ZM17 14.867c.594 0 .855.082.98.192.106.086.22.28.22.843h.937c0-.64-.121-1.195-.551-1.562-.406-.344-.98-.41-1.586-.41Zm-3.234 14.906a2.7 2.7 0 0 0 1.093-1.93l-.933-.09a1.78 1.78 0 0 1-.715 1.267Zm0 0"
      />
      <path
        style="fill-rule:nonzero;fill:#fff;fill-opacity:1;stroke-width:1.25;stroke-linecap:butt;stroke-linejoin:miter;stroke:#004d49;stroke-opacity:1;stroke-miterlimit:4"
        d="M29.266 11.823h10.797a4.374 4.374 0 0 1 4.374 4.375v27.599a4.374 4.374 0 0 1-4.374 4.375H29.266a4.374 4.374 0 0 1-4.375-4.375v-27.6a4.374 4.374 0 0 1 4.375-4.374Zm0 0"
        transform="scale(.75)"
      />
      <path
        style="stroke:none;fill-rule:nonzero;fill:#004d49;fill-opacity:1"
        d="M14.094 39.645a.47.47 0 0 0-.051.66.47.47 0 0 0 .66.05Zm2.476-.891 3.735-3.2-.61-.71-3.734 3.199Zm-1.867 1.601 1.867-1.601-.61-.711-1.866 1.602Zm0 0"
      />
      <path
        style="fill:none;stroke-width:1.25;stroke-linecap:butt;stroke-linejoin:miter;stroke:#004d49;stroke-opacity:1;stroke-miterlimit:4"
        d="M34.266 28a9.8 9.8 0 0 0-4.006.87.9.9 0 0 0-.5.734l-.588 6.1a1 1 0 0 0 .995 1.099h8.198a1 1 0 0 0 .74-.329.98.98 0 0 0 .254-.77l-.588-6.1a.88.88 0 0 0-.5-.734 9.8 9.8 0 0 0-4.005-.87Zm0 0"
        transform="scale(.75)"
      />
      <path
        style="fill-rule:nonzero;fill:#004d49;fill-opacity:1;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke:#004d49;stroke-opacity:1;stroke-miterlimit:4"
        d="M36.563 23.198a1.898 1.898 0 1 1-3.797 0c0-1.047.849-1.901 1.9-1.901a1.9 1.9 0 0 1 1.897 1.9Zm0 0"
        transform="scale(.75)"
      />
      <path
        style="fill:none;stroke-width:1.25;stroke-linecap:round;stroke-linejoin:miter;stroke:#004d49;stroke-opacity:1;stroke-miterlimit:4"
        d="M30.667 44.797h8m-4-12h2.395"
        transform="scale(.75)"
      />
      <path
        style="fill:none;stroke-width:1.25;stroke-linecap:butt;stroke-linejoin:miter;stroke:#004d49;stroke-opacity:1;stroke-miterlimit:4"
        d="M44.49 19.422h.572a2.176 2.176 0 1 1 0 4.354h-.572Zm0 9.203h.572a2.175 2.175 0 1 1 0 4.349h-.572Zm0-4.802h.572a2.175 2.175 0 1 1 0 4.349h-.572Zm0 9.198h.572a2.176 2.176 0 1 1 0 4.354h-.572Zm0 0"
        transform="scale(.75)"
      />
    </svg>
  `,
  standalone: true,
})
export class SvgVideoChatCircled {}
